import { __awaiter } from '../_virtual/_tslib.js';
import { useState, useRef, useEffect, useCallback } from 'react';

function useGenericAsyncHandler(asyncFn) {
    const [loading, setLoading] = useState(false);
    const isMountedRef = useRef(true);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    const execute = useCallback((...args) => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        try {
            const result = yield asyncFn(...args);
            return result;
        }
        finally {
            // Only update state if component is still mounted
            if (isMountedRef.current) {
                setLoading(false);
            }
        }
    }), [asyncFn]);
    return { execute, loading };
}

export { useGenericAsyncHandler };
//# sourceMappingURL=useGenericAsyncHandler.js.map
